// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".hoverable[data-v-3a671be2]:hover{background-color:#add8e6}a[data-v-3a671be2]{text-decoration:none}.logo[data-v-3a671be2]{text-align:center;color:#fff}.lateral_bar[data-v-3a671be2]{box-shadow:1px 2px 5px 1px rgba(0,0,0,.14);-webkit-box-shadow:1px 2px 5px 1px rgba(0,0,0,.14);-moz-box-shadow:1px 2px 5px 1px rgba(0,0,0,.14)}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
